export default "__VITE_ASSET__CilW4hxL__"